import { Theme } from 'constants/theme';

export const getThemeCSSClass = (theme?: Theme) => theme && `theme_${theme}`;

export function getThemeStyles({
  stylesNew,
  stylesOld,
  theme
}: {
  stylesNew: Record<string, string>;
  stylesOld: Record<string, string>;
  theme: ThemeSelect;
}): Record<string, string> {
  return theme === 'new' ? stylesNew : stylesOld;
}
